export default __webpack_public_path__ + "static/media/overwatch-theme.76802417.mp3";